module.exports = __webpack_public_path__ + "static/media/05-03.63590d37.png";